import { all } from 'redux-saga/effects';
import sessionSaga from '../features/session/saga';

export default function* rootSaga() {
  yield all([
    sessionSaga(),
  ]);
}
